import { useLocalization } from "@fluent/react";
import { FilterChips, FilterType, FILTER_CONFIG } from "./filterConfig";
import { MultiSelectFilter } from "./common";

const StatusFilter = ({
  isActive,
  filters,
  handleSetFilter,
  handleSetActive,
  handleToggleFilter,
}: FilterType) => {
  const { l10n } = useLocalization();
  const label = l10n.getString(FILTER_CONFIG[FilterChips.STATUS].labelKey);

  return (
    <MultiSelectFilter
      isActive={isActive}
      filters={filters}
      handleSetFilter={handleSetFilter}
      handleSetActive={handleSetActive}
      handleToggleFilter={handleToggleFilter}
      filterName={FilterChips.STATUS}
      filterOptions={FILTER_CONFIG[FilterChips.STATUS].options}
      label={label}
    />
  );
};

export default StatusFilter;
